import DiversityImage from './diversity.png';
import NapImage from './nap.png';
import { colors } from '../../../colors';
import { useDimensions } from '../../../hooks/useDimensions';

const WhichSubscription2 = () => {
  const { dimensions: rootDimensions, ref: rootRef } = useDimensions();

  const chartWidth = ((rootDimensions?.width ?? 0) / 2) * 0.6;

  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        width: '100%',
        justifyContent: 'space-evenly',
      }}
      ref={rootRef}
    >
      <div
        style={{
          width: '50%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <p
          style={{
            color: colors.white,
            fontSize: 28,
            margin: 0,
            marginBottom: 30,
          }}
        >
          Diversity
        </p>
        <img
          src={DiversityImage}
          width={chartWidth}
          height={(rootDimensions?.height ?? 0) * 0.7}
        />
      </div>
      <div
        style={{
          width: '50%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <p
          style={{
            color: colors.white,
            fontSize: 28,
            margin: 0,
            marginBottom: 30,
          }}
        >
          Non-algorithmic difference
        </p>
        <img
          src={NapImage}
          width={chartWidth}
          height={(rootDimensions?.height ?? 0) * 0.7}
        />
      </div>
    </div>
  );
};

export default WhichSubscription2;
